/**
 * Created by eladd on 8/31/2017.
 */
import {Pipe, PipeTransform} from "@angular/core";
import * as _ from "lodash";

@Pipe({
	name: 'cpPluck',
	pure:true
})
export class PluckPipe implements PipeTransform {
	transform<T>(keys:string[],object:any) {
		return keys.map(x=>object[x]);
	}
}
